import { ApplicationInsights } from '@microsoft/applicationinsights-web'

const setupAppInsights = (trackingId: string): ApplicationInsights => {
    const appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: trackingId,
            autoTrackPageVisitTime: true,
            enableAutoRouteTracking: true,
            disableCookiesUsage: true,
        },
    })
    appInsights.loadAppInsights()

    return appInsights
}

export default setupAppInsights
